import styled from 'styled-components'

export const Layout = styled.div`
  min-height: 100vh;

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: 250px 1fr;
  }
`

export const Main = styled.main`
  background: ${({ theme }) => theme.sidebarWrapperBackground};
  min-height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
`

export const MainContent = styled.div`
  margin-left: auto;
  margin-right: auto;
  margin-top: 32px; /* header height */
  max-width: 1440px;
  padding: 2rem 1.5rem;
  width: 100%;

  @media (max-width: 768px) {
    padding: 1.25rem 1rem 2rem;
  }

  > h1 {
    margin: ${({ $titleMarginMobile }) => $titleMarginMobile};

    @media (min-width: 768px) {
      margin: ${({ $titleMargin }) => $titleMargin};
    }

    @media (max-width: 768px) {
      font-size: 1.5rem;
      line-height: 1.25;
    }
  }

  > p {
    @media (max-width: 768px) {
      font-size: 0.875rem;
      line-height: 1.5;
      margin-bottom: 0.25rem;
    }
  }
`

export const SidebarWrapper = styled.aside`
  width: 250px;
  z-index: 1000;

  /* MOBILE */
  height: 100vh;
  left: 0;
  position: fixed;
  top: 0;
  transform: ${({ open }) => (open ? 'translateX(0)' : 'translateX(-100%)')};
  transition: transform 0.25s ease-in-out;

  /* DESKTOP */
  @media (min-width: 768px) {
    position: sticky;
    top: 0;
    transform: none;
  }
`
